import { FormControl } from '@angular/forms';

export class EmailValidator {

  static isValid(value) {
    return /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(value);
  }
}
